document.addEventListener("DOMContentLoaded", function () {

  // Получаем локализованные строки из HTML или Shopify
  const translations = {
    remove: document.querySelector('[data-translation="cart.general.remove"]')?.textContent || "Supprimer",
    empty: document.querySelector('[data-translation="cart.general.empty"]')?.textContent || "Votre panier est vide",
  };

  // French translations for personalized bracelet properties
  const propertyTranslations = {
    'size': 'Taille',
    'beads-size': 'Taille des perles',
    'bead-size': 'Taille des perles',
    'beads size': 'Taille des perles',
    'bead-1': 'Perle 1',
    'bead-2': 'Perle 2', 
    'bead-3': 'Perle 3',
    'bead-4': 'Perle 4',
    'bead-5': 'Perle 5',
    'bead-6': 'Perle 6',
    'bead-7': 'Perle 7',
    'bead-8': 'Perle 8',
    'stone': 'Pierre',
    'stone-1': 'Pierre 1',
    'stone-2': 'Pierre 2',
    'stone-3': 'Pierre 3',
    'color': 'Couleur',
    'colour': 'Couleur',
    'material': 'Matériau',
    'length': 'Longueur',
    'width': 'Largeur',
    'diameter': 'Diamètre',
    'personalization': 'Personnalisation',
    'engraving': 'Gravure',
    'custom': 'Personnalisé',
    'note': 'Note',
    'special-request': 'Demande spéciale',
    'bracelet size': 'Taille du bracelet',
    'wrist size': 'Tour de poignet',
    'gemstone': 'Pierre précieuse',
    'crystal': 'Cristal'
  };

  // Helper function to translate property keys
  const translatePropertyKey = (key) => {
    // Try exact match first
    const lowerKey = key.toLowerCase();
    if (propertyTranslations[lowerKey]) {
      return propertyTranslations[lowerKey];
    }
    
    // Try partial matches for dynamic keys (like "bead-9", "stone-4", etc.)
    if (lowerKey.startsWith('bead-')) {
      const number = lowerKey.replace('bead-', '');
      return `Perle ${number}`;
    }
    
    if (lowerKey.startsWith('stone-')) {
      const number = lowerKey.replace('stone-', '');
      return `Pierre ${number}`;
    }
    
    // Return original key if no translation found
    return key;
  };

  // Функция для проверки состояния сети
  const checkNetworkStatus = () => {
    if (!navigator.onLine) {
      console.warn("No internet connection. Please check your network and try again.");
      return false;
    }
    return true;
  };

  // Функция для выполнения запроса с повторными попытками
  const fetchWithRetry = async (url, options, retries = 3, delay = 500) => {
    for (let i = 0; i < retries; i++) {
      if (!checkNetworkStatus()) {
        console.warn(`Attempt ${i + 1} failed: No internet connection.`);
        if (i < retries - 1) {
          await new Promise(resolve => setTimeout(resolve, delay));
          continue;
        }
        throw new Error("No internet connection after all retries.");
      }

      try {
        const response = await fetch(url, options);
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(`HTTP error! status: ${response.status}, description: ${errorData.description || 'Unknown error'}`);
        }
        return response;
      } catch (error) {
        console.error(`Attempt ${i + 1} failed:`, error);
        if (i < retries - 1) {
          await new Promise(resolve => setTimeout(resolve, delay));
        } else {
          throw error;
        }
      }
    }
  };

  // Функция для получения данных корзины
  const fetchCartData = async () => {
    try {
      const response = await fetchWithRetry('/cart.js', {});
      return await response.json();
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return null;
    }
  };

  // Debounce функция для ограничения частоты вызовов
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };

  // Таймер
  document.querySelectorAll(".offer-timer").forEach((timer) => {
    let minutes = parseInt(timer.dataset.timerMinutes) || 13;
    let timeLeft = minutes * 60;
    let timerText = timer.querySelector("[data-timer]");

    function updateTimer() {
      let mins = Math.floor(timeLeft / 60);
      let secs = timeLeft % 60;
      timerText.textContent = `${mins}:${secs < 10 ? "0" : ""}${secs}`;
      if (timeLeft > 0) {
        timeLeft--;
        setTimeout(updateTimer, 1000);
      }
    }
    updateTimer();
  });

  // Функция для ручного обновления содержимого корзины
  const updateCartItemsManually = async (cart) => {
    const cartItemsBlock = document.querySelector('.cart-items');
    if (!cartItemsBlock) {
      console.warn("Cart items block not found on the page.");
      return;
    }

    cartItemsBlock.innerHTML = '';

    if (cart.items.length === 0) {
      cartItemsBlock.innerHTML = `<p class="h5 text-center">${translations.empty}</p>`;
      
      // Check if recommendations should be shown in empty cart
      const settingsElement = document.getElementById('cart-drawer-settings');
      if (settingsElement) {
        const settings = JSON.parse(settingsElement.textContent);
        if (settings.show_recommendations_when_empty) {
          // Don't hide recommendations blocks - they should stay visible
        }
      }
      return;
    }

    const deleteIconUrl = window.themeAssets?.deleteIcon || '//lespierresdubienetre.fr/cdn/shop/t/63/assets/delete.png';
    let itemsHtml = '';
    
    cart.items.forEach((item, index) => {
      
      // Use final_price to show discounted prices, including free items
      let displayPrice = item.final_price / 100;
      const originalPrice = item.price / 100;
      let showOriginalPrice = originalPrice > displayPrice;
      
      // Special price calculation for custom bracelets
      if (item.product_title && item.product_title.toLowerCase().includes('bracelet de lithothérapie personnalisé')) {
        // Calculate custom price: base price + property additions
        let customPrice = originalPrice; // Start with base price (29.90)
        let propertyPriceSum = 0;
        
        if (item.properties && Object.keys(item.properties).length > 0) {
          for (const [key, value] of Object.entries(item.properties)) {
            const stringValue = String(value || '').trim();
            if (stringValue && !key.startsWith('_')) {
              // Extract price addition from property value like "15cm ( +0,50€ )"
              const priceMatch = stringValue.match(/\+(\d+[,.]?\d*)\s*€/);
              if (priceMatch) {
                // Convert comma to dot for proper parsing (European format)
                const priceAddition = parseFloat(priceMatch[1].replace(',', '.'));
                propertyPriceSum += priceAddition;
              }
            }
          }
        }
        
        customPrice += propertyPriceSum;
        displayPrice = customPrice;
        showOriginalPrice = false; // Don't show original price for custom calculation
      }
      
      // Build properties/variant info HTML
      let propertiesHtml = '';
      
      // Add variant title if it's not a default variant
      if (item.variant_title && item.variant_title !== 'Default Title') {
        propertiesHtml += `<p class="smallcaps text-subdued">${item.variant_title}</p>`;
      }
      
      // Add line item properties (like size, bead-size, etc.)
      if (item.properties && Object.keys(item.properties).length > 0) {
        propertiesHtml += '<ul class="text-subdued">';
        for (const [key, value] of Object.entries(item.properties)) {
          // Skip empty values and internal properties (starting with _)
          // Convert value to string to safely use trim()
          const stringValue = String(value || '');
          if (stringValue && stringValue.trim() !== '' && !key.startsWith('_')) {
            // Translate property key to French
            const translatedKey = translatePropertyKey(key);
            propertiesHtml += `<li>${translatedKey}: ${stringValue}</li>`;
          }
        }
        propertiesHtml += '</ul>';
      }
      
      // Check if item should show "article offert" banner
      const shouldShowOfferBanner = displayPrice === 0 && 
        !item.product_title.toLowerCase().includes('cadeau');
      
      itemsHtml += `
        <line-item class="line-item">
          <img class="line-item__media" src="${item.image}" alt="${item.product_title}" width="50" height="auto">
          <div class="line-item-info">
            <img src="${deleteIconUrl}" alt="" class="link text-xs cart-item__remove" data-id="${item.id}"/>
            <div class="v-stack">
              <p class="h6">${item.product_title}</p>
              ${propertiesHtml ? `<div class="v-stack justify-items-start gap-1">${propertiesHtml}</div>` : ''}
            </div>
            <div class="list-item-bottom-info">
              <line-item-quantity class="h-stack cart-quantity-selector">
                <cart-quantity-selector>
                  <button class="quantity-btn quantity-decrement" data-id="${item.id}">-</button>
                  <span class="quantity">${item.quantity}</span>
                  <button class="quantity-btn quantity-increment" data-id="${item.id}">+</button>
                </cart-quantity-selector>
              </line-item-quantity>
              <div class="price-list">
                ${showOriginalPrice ? `<span class="prev-price">${originalPrice.toFixed(2)}€</span>` : ''}
                <span class="price">${displayPrice.toFixed(2)}€</span>
                ${shouldShowOfferBanner ? '<div class="offer-banner" style="background-color: #dc3545; color: white; padding: 2px 6px; font-size: 10px; font-weight: bold; text-align: center; margin-top: 4px; border-radius: 3px;">ARTICLE OFFERT</div>' : ''}
              </div>
            </div>
          </div>
        </line-item>
      `;
    });

    cartItemsBlock.innerHTML = itemsHtml;

    // Hide products based on properties from other cart items - function declaration moved here
    const hideProductsBasedOnProperties = (cart) => {
      // Step 1: Collect property values and categorize them
      const sizeValues = new Set(); // For size-related properties (contains logic)
      const beadValues = new Set(); // For bead-related properties (exact match logic)
      
      cart.items.forEach(item => {
        if (item.properties && Object.keys(item.properties).length > 0) {
          for (const [key, value] of Object.entries(item.properties)) {
            const stringValue = String(value || '').trim();
            if (stringValue && !key.startsWith('_')) {
              // Extract the actual value part (remove price info like " ( +0,50€ )")
              const cleanValue = stringValue.replace(/\s*\([^)]*\)\s*/g, '').trim();
              if (cleanValue) {
                // Categorize based on property key
                if (key.toLowerCase().includes('size')) {
                  // Size-related properties (size, beads-size, etc.)
                  sizeValues.add(cleanValue);
                } else if (key.toLowerCase().includes('bead') && !key.toLowerCase().includes('size')) {
                  // Bead-related properties (bead-1, bead-2, etc.) but not bead-size
                  beadValues.add(cleanValue);
                }
              }
            }
          }
        }
      });

      // Step 2: Hide products based on different matching rules
      const lineItems = document.querySelectorAll('.cart-items line-item');
      
      lineItems.forEach((lineItem, index) => {
        const titleElement = lineItem.querySelector('.h6, p, a');
        if (!titleElement) return;
        
        const itemTitle = titleElement.textContent.trim();
        const itemTitleLower = itemTitle.toLowerCase();
        let shouldHide = false;
        
        // Check size values using "contains" logic
        sizeValues.forEach(value => {
          if (itemTitleLower.includes(value.toLowerCase())) {
            shouldHide = true;
          }
        });
        
        // Check bead values using "exact match" logic
        beadValues.forEach(value => {
          if (itemTitle === value) {
            shouldHide = true;
          }
        });
        
        if (shouldHide) {
          lineItem.style.display = 'none';
        } else {
          lineItem.style.display = '';
        }
      });
    
    };

    // Hide products based on properties from other cart items
    hideProductsBasedOnProperties(cart);

    // Привязываем обработчики для кнопок изменения количества и удаления
    document.querySelectorAll('.quantity-decrement').forEach(button => {
      button.addEventListener('click', async () => {
        const itemId = button.getAttribute('data-id');
        const currentItem = cart.items.find(item => item.id.toString() === itemId);
        if (currentItem && currentItem.quantity > 1) {
          try {
            // Check if this is a custom bracelet
            const isCustomBracelet = currentItem.product_title && 
              currentItem.product_title.toLowerCase().includes('bracelet de lithothérapie personnalisé');
            
            if (isCustomBracelet && currentItem.properties) {
              
              // Extract property values from this bracelet
              const sizeValues = new Set();
              const beadValues = new Set();
              
              for (const [key, value] of Object.entries(currentItem.properties)) {
                const stringValue = String(value || '').trim();
                if (stringValue && !key.startsWith('_')) {
                  const cleanValue = stringValue.replace(/\s*\([^)]*\)\s*/g, '').trim();
                  if (cleanValue) {
                    if (key.toLowerCase().includes('size')) {
                      sizeValues.add(cleanValue);
                    } else if (key.toLowerCase().includes('bead') && !key.toLowerCase().includes('size')) {
                      beadValues.add(cleanValue);
                    }
                  }
                }
              }
              
              
              // First, decrease the bracelet quantity
            await fetchWithRetry('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: itemId, quantity: currentItem.quantity - 1 }),
            });
              
              // Then decrease quantities of related items (but don't go below 0)
              const itemsToUpdate = [];
              
              cart.items.forEach(item => {
                if (item.id.toString() === itemId) return; // Skip the bracelet itself
                
                const itemTitle = item.product_title.trim();
                const itemTitleLower = itemTitle.toLowerCase();
                let shouldDecrease = false;
                let matchedValue = null;
                
                // Check size values using "contains" logic
                sizeValues.forEach(value => {
                  if (itemTitleLower.includes(value.toLowerCase())) {
                    shouldDecrease = true;
                    matchedValue = value;
                  }
                });
                
                // Check bead values using "exact match" logic
                beadValues.forEach(value => {
                  if (itemTitle === value) {
                    shouldDecrease = true;
                    matchedValue = value;
                  
                  }
                });
                
                if (shouldDecrease && item.quantity > 0) {
                  const newQuantity = Math.max(0, item.quantity - 1);
                  if (newQuantity >= 0) {
                    itemsToUpdate.push({
                      id: item.id.toString(),
                      newQuantity: newQuantity,
                      title: itemTitle
                    });
                  }
                }
              });
              
              // Update quantities of all related items
              for (const item of itemsToUpdate) {
                
                await fetchWithRetry('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: item.id, quantity: item.newQuantity }),
                });
              }
              
            } else {
              // Regular item, just decrease its quantity
              await fetchWithRetry('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: itemId, quantity: currentItem.quantity - 1 }),
              });
            }
            
            // Manually update cart without page reload
            await updateCartManually();
          } catch (error) {
            console.error("Error decreasing quantity:", error);
          }
        }
      });
    });

    document.querySelectorAll('.quantity-increment').forEach(button => {
      button.addEventListener('click', async () => {
        const itemId = button.getAttribute('data-id');
        const currentItem = cart.items.find(item => item.id.toString() === itemId);
        if (currentItem) {
          try {
            // Check if this is a custom bracelet
            const isCustomBracelet = currentItem.product_title && 
              currentItem.product_title.toLowerCase().includes('bracelet de lithothérapie personnalisé');
            
            if (isCustomBracelet && currentItem.properties) {
              
              
              // Extract property values from this bracelet
              const sizeValues = new Set();
              const beadValues = new Set();
              
              for (const [key, value] of Object.entries(currentItem.properties)) {
                const stringValue = String(value || '').trim();
                if (stringValue && !key.startsWith('_')) {
                  const cleanValue = stringValue.replace(/\s*\([^)]*\)\s*/g, '').trim();
                  if (cleanValue) {
                    if (key.toLowerCase().includes('size')) {
                      sizeValues.add(cleanValue);
                    } else if (key.toLowerCase().includes('bead') && !key.toLowerCase().includes('size')) {
                      beadValues.add(cleanValue);
                    }
                  }
                }
              }
              
              
              
              // First, increase the bracelet quantity
            await fetchWithRetry('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: itemId, quantity: currentItem.quantity + 1 }),
            });
              
              // Then increase quantities of related items
              const itemsToUpdate = [];
              
              cart.items.forEach(item => {
                if (item.id.toString() === itemId) return; // Skip the bracelet itself
                
                const itemTitle = item.product_title.trim();
                const itemTitleLower = itemTitle.toLowerCase();
                let shouldIncrease = false;
                let matchedValue = null;
                
                // Check size values using "contains" logic
                sizeValues.forEach(value => {
                  if (itemTitleLower.includes(value.toLowerCase())) {
                    shouldIncrease = true;
                    matchedValue = value;
                    
                  }
                });
                
                // Check bead values using "exact match" logic
                beadValues.forEach(value => {
                  if (itemTitle === value) {
                    shouldIncrease = true;
                    matchedValue = value;
                    
                  }
                });
                
                if (shouldIncrease) {
                  itemsToUpdate.push({
                    id: item.id.toString(),
                    newQuantity: item.quantity + 1,
                    title: itemTitle
                  });
                }
              });
              
              // Update quantities of all related items
              for (const item of itemsToUpdate) {
                
          await fetchWithRetry('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: item.id, quantity: item.newQuantity }),
                });
              }
              
            } else {
              // Regular item, just increase its quantity
              await fetchWithRetry('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: itemId, quantity: currentItem.quantity + 1 }),
              });
            }
            
            // Manually update cart without page reload
            await updateCartManually();
        } catch (error) {
            console.error("Error increasing quantity:", error);
          }
        }
      });
    });

    document.querySelectorAll('.cart-item__remove').forEach(button => {
      button.addEventListener('click', async () => {
        const itemId = button.getAttribute('data-id');
        
        
        // Find the item details for debugging
        const currentItem = cart.items.find(item => item.id.toString() === itemId);
        if (currentItem) {
          
        } else {
          console.warn(`Could not find item with ID ${itemId} in cart`);
          return;
        }
        
        try {
          // Check if this is a custom bracelet
          const isCustomBracelet = currentItem.product_title && 
            currentItem.product_title.toLowerCase().includes('bracelet de lithothérapie personnalisé');
          
          let itemsToRemove = [];
          
          if (isCustomBracelet && currentItem.properties) {
            // Find all related products that should be removed with this bracelet
            const sizeValues = new Set();
            const beadValues = new Set();
            
            // Extract property values from this bracelet
            for (const [key, value] of Object.entries(currentItem.properties)) {
              const stringValue = String(value || '').trim();
              if (stringValue && !key.startsWith('_')) {
                const cleanValue = stringValue.replace(/\s*\([^)]*\)\s*/g, '').trim();
                if (cleanValue) {
                  if (key.toLowerCase().includes('size')) {
                    sizeValues.add(cleanValue);
                  } else if (key.toLowerCase().includes('bead') && !key.toLowerCase().includes('size')) {
                    beadValues.add(cleanValue);
                  }
                }
              }
            }
            
            
            
            // Count how many custom bracelets in cart use each property value
            const propertyUsageCount = new Map();
            
            cart.items.forEach(item => {
              if (item.product_title && item.product_title.toLowerCase().includes('bracelet de lithothérapie personnalisé') && item.properties) {
                for (const [key, value] of Object.entries(item.properties)) {
                  const stringValue = String(value || '').trim();
                  if (stringValue && !key.startsWith('_')) {
                    const cleanValue = stringValue.replace(/\s*\([^)]*\)\s*/g, '').trim();
                    if (cleanValue) {
                      const count = propertyUsageCount.get(cleanValue) || 0;
                      propertyUsageCount.set(cleanValue, count + 1);
                    }
                  }
                }
              }
            });
            
            
            
            // Find items to remove and track quantities needed
            const itemsToRemoveMap = new Map(); // item_id -> quantity_to_remove
            
            cart.items.forEach(item => {
              if (item.id.toString() === itemId) return; // Skip the bracelet itself
              
              const itemTitle = item.product_title.trim();
              const itemTitleLower = itemTitle.toLowerCase();
              let shouldRemove = false;
              let matchedValue = null;
              
              // Check size values using "contains" logic
              sizeValues.forEach(value => {
                if (itemTitleLower.includes(value.toLowerCase())) {
                  shouldRemove = true;
                  matchedValue = value;
                  
                }
              });
              
              // Check bead values using "exact match" logic
              beadValues.forEach(value => {
                if (itemTitle === value) {
                  shouldRemove = true;
                  matchedValue = value;
                  
                }
              });
              
              if (shouldRemove && matchedValue) {
                const usageCount = propertyUsageCount.get(matchedValue) || 0;
                
                // Only remove if this is the last bracelet using this property
                // OR remove just 1 quantity if multiple bracelets use it
                if (usageCount === 1) {
                  // This bracelet is the only one using this property, remove all quantities
                  itemsToRemoveMap.set(item.id.toString(), item.quantity);
                  
                } else {
                  // Multiple bracelets use this property, remove just 1 quantity
                  const currentQuantityToRemove = itemsToRemoveMap.get(item.id.toString()) || 0;
                  itemsToRemoveMap.set(item.id.toString(), currentQuantityToRemove + 1);
                  
                }
              }
            });
            
            // Add items to remove list with their specific quantities
            itemsToRemoveMap.forEach((quantityToRemove, itemIdToRemove) => {
              const item = cart.items.find(i => i.id.toString() === itemIdToRemove);
              if (item) {
                // Calculate new quantity (current - quantity_to_remove)
                const newQuantity = Math.max(0, item.quantity - quantityToRemove);
                
                
                if (newQuantity === 0) {
                  itemsToRemove.push(itemIdToRemove);
                } else {
                  // We need to update quantity instead of removing completely
                  itemsToRemove.push({ id: itemIdToRemove, newQuantity: newQuantity });
                }
              }
            });
          }
          
          
          
          // First remove the bracelet itself
          const braceletResponse = await fetchWithRetry('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: itemId, quantity: 0 }),
          });
          
          const braceletResult = await braceletResponse.json();
          
          
          // Then remove/update all related items
          for (const item of itemsToRemove) {
            if (typeof item === 'string') {
              // Complete removal (quantity = 0)
              const response = await fetchWithRetry('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item, quantity: 0 }),
              });
              
              const result = await response.json();
              
            } else {
              // Quantity update
              const response = await fetchWithRetry('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.id, quantity: item.newQuantity }),
              });
              
              const result = await response.json();
              
            }
          }
          
          // Manually update the cart without triggering page reload
          
          await updateCartManually();
          
    } catch (error) {
          console.error("Error removing item:", error);
        }
      });
    });

    // Apply our stone hiding logic AFTER the cart is built
    // setTimeout(() => applyStoneProductLogic(), 100); // Removed - no longer hiding stone products
  };

  // Separate function to apply our stone product hiding logic
  // REMOVED - No longer needed since we want to show all products
  /*
  const applyStoneProductLogic = async () => {
    // Function removed - we now show all products without filtering
  };
  */

  // Rate limiting for cart updates
  let lastUpdateTime = 0;
  const UPDATE_THROTTLE_MS = 2000; // Minimum 2 seconds between updates (increased from 1)
  
  // Global API call tracking
  let apiCallCount = 0;
  let apiCallWindowStart = Date.now();
  const API_CALL_LIMIT = 10; // Max 10 API calls per minute
  const API_CALL_WINDOW = 60000; // 1 minute window
  
  // Function to check if we can make an API call
  const canMakeApiCall = () => {
    const now = Date.now();
    
    // Reset counter if window has passed
    if (now - apiCallWindowStart > API_CALL_WINDOW) {
      apiCallCount = 0;
      apiCallWindowStart = now;
    }
    
    if (apiCallCount >= API_CALL_LIMIT) {
      console.warn(`API call limit reached (${API_CALL_LIMIT} calls per minute). Skipping request.`);
      return false;
    }
    
    return true;
  };
  
  // Increment API call counter
  const incrementApiCallCount = () => {
    apiCallCount++;
    
  };

  // Manual cart update function that doesn't trigger page reload
  const updateCartManually = async () => {
    console.log("🔄 updateCartManually called");
    
    const now = Date.now();
    if (now - lastUpdateTime < UPDATE_THROTTLE_MS) {
      console.log("⏱️ Throttled - skipping update");
      return;
    }
    lastUpdateTime = now;
    
    console.log("🔄 Proceeding with cart update");
    
    try {
      const cart = await fetchCartData();
      if (cart) {
        console.log("Cart data fetched, items count:", cart.items.length);
        await syncPochettesCheckbox();
        await updateCartItemsManually(cart);
        await updateCartTotal(cart);
        await updateProgressBars(cart);
        
        // Always bind AJOUTER buttons, even for empty cart (for recommendations)
        bindAjouterButtons();
        
        console.log("✅ Cart update completed");
      }
    } catch (error) {
      console.error("Error during manual cart update:", error);
    }
  };

  // Helper function to update bracelet price display
  // REMOVED - No longer needed since we're not adjusting prices
  /*
  const updateBraceletPrice = (lineItem, titleElement, adjustedPrice, indicatorText) => {
    // Function removed - we now show original prices without adjustments
  };
  */

  // Прогресс-бар
  const updateProgressBars = async (cart) => {
    
    const progressBars = document.querySelectorAll(".progress-bar");
    

    const cartTotal = cart.total_price / 100;

    progressBars.forEach((bar) => {
      let progressBar = bar.querySelector("#progress-bar");
      let offerText = bar.querySelector("#offer-text");
      let thresholdShipping = parseInt(bar.dataset.thresholdShipping) || 20;
      let thresholdGift = parseInt(bar.dataset.thresholdGift) || 80;
      let progressMode = bar.dataset.progressMode || "shipping_and_gift";
      let textBelow = bar.dataset.textBelow;
      let textMid = bar.dataset.textMid;
      let textComplete = bar.dataset.textComplete || "Поздравляем! Вы получили бесплатную доставку и подарок!";


      let targetThreshold, remaining, textTemplate;

      if (progressMode === "shipping_only") {
        targetThreshold = thresholdShipping;
        if (cartTotal >= thresholdShipping) {
          offerText.textContent = textComplete;
        } else {
          remaining = Math.ceil(thresholdShipping - cartTotal);
          remaining = remaining.toFixed(2);
          textTemplate = textBelow;
          offerText.textContent = textTemplate.replace("[remaining]", remaining);
        }
        progressDivider.style.display = "none";
        
        // Position the tag at 50% for single mode
        const giftTag = bar.querySelector('.progress-bar-tag');
        if (giftTag) {
          giftTag.style.right = "50%";
        }
      } else if (progressMode === "gift_only") {
        targetThreshold = thresholdGift;
        if (cartTotal >= thresholdGift) {
          offerText.textContent = textComplete;
        } else {
          remaining = Math.ceil(thresholdGift - cartTotal);
          remaining = remaining.toFixed(2);
          textTemplate = textBelow;
          offerText.textContent = textTemplate.replace("[remaining]", remaining);
        }
        
        // Position the tag at 50% for single mode
        const giftTag = bar.querySelector('.progress-bar-tag');
        if (giftTag) {
          giftTag.style.right = "50%";
        }
      } else {
        // shipping_and_gift mode: gift threshold is lower, shipping threshold is higher
        if (cartTotal >= thresholdShipping) {
          // Both thresholds achieved
          offerText.textContent = textComplete;
          targetThreshold = thresholdShipping;
        } else if (cartTotal >= thresholdGift) {
          // Gift achieved, working toward shipping
          remaining = Math.ceil(thresholdShipping - cartTotal);
          remaining = remaining.toFixed(2);
          textTemplate = textMid;
          targetThreshold = thresholdShipping;
          offerText.textContent = textTemplate.replace("[remaining]", remaining);
        } else {
          // Working toward gift threshold
          remaining = Math.ceil(thresholdGift - cartTotal);
          remaining = remaining.toFixed(2);
          textTemplate = textBelow;
          targetThreshold = thresholdGift;
          offerText.textContent = textTemplate.replace("[remaining]", remaining);
        }
        let midPoint = (thresholdGift / thresholdShipping) * 100;
        
        // Position the gift tag at the gift threshold position
        const giftTag = bar.querySelector('.progress-bar-tag');
        if (giftTag) {
          giftTag.style.right = `65%`;
        }
      }

      // Calculate progress based on mode and current phase
      let progress;
      if (progressMode === "shipping_only") {
        // Simple progress to shipping threshold
        progress = Math.min((cartTotal / thresholdShipping) * 100, 100);
      } else if (progressMode === "gift_only") {
        // Simple progress to gift threshold
        progress = Math.min((cartTotal / thresholdGift) * 100, 100);
      } else {
        // shipping_and_gift mode: more complex calculation
        if (cartTotal >= thresholdShipping) {
          // Both thresholds achieved - 100%
          progress = 100;
        } else if (cartTotal >= thresholdGift) {
          // Gift achieved, working toward shipping
          // Progress from gift threshold to shipping threshold
          const progressInSecondPhase = (cartTotal - thresholdGift) / (thresholdShipping - thresholdGift);
          const giftPhasePercentage = 35;
          const remainingPercentage = 100 - giftPhasePercentage;
          progress = giftPhasePercentage + (65* (cartTotal/thresholdShipping));
        } else {
          // Working toward gift threshold
          // Progress from 0 to gift threshold position
          const progressInFirstPhase = cartTotal / thresholdGift;
          const giftPhasePercentage = (thresholdGift / thresholdShipping) * 100;
          progress = progressInFirstPhase * giftPhasePercentage;
        }
      }
      
      progress = Math.min(Math.max(progress, 0), 100); // Ensure progress is between 0-100%
      
      progressBar.style.width = `${progress}%`;

      const labels = bar.querySelectorAll('.offer-label');
      labels.forEach(label => {
        // Safety check: ensure label exists and has classList
        if (!label || !label.classList) {
          return;
        }
        
        const labelType = label.getAttribute('data-label');
        if (labelType === 'cadeau-offert' && progressMode !== "shipping_only" && cartTotal >= thresholdGift) {
          label.classList.add('completed');
          if (!label.querySelector('.checkmark')) {
            label.insertAdjacentHTML('beforeend', '<span class="checkmark">✔</span>');
          }
        } else if (labelType === 'bracelet-offert' && progressMode !== "gift_only" && cartTotal >= thresholdShipping) {
          label.classList.add('completed');
          if (!label.querySelector('.checkmark')) {
            label.insertAdjacentHTML('beforeend', '<span class="checkmark">✔</span>');
          }
        } else {
          label.classList.remove('completed');
          const checkmark = label.querySelector('.checkmark');
          if (checkmark) {
            checkmark.remove();
          }
        }
      });
    });

    console.log("📊 updateProgressBars called - checking for gift removal");
    
    // First check if gift should be removed
    const giftRemoved = await removeGiftIfNotEligible(cart);
    
    console.log("Gift removed result:", giftRemoved);
    
    // If gift was removed, update cart data before checking for gift eligibility
    if (giftRemoved) {
      console.log("Gift was removed - fetching updated cart data and refreshing display");
      
      // Get updated cart data after gift removal
      const updatedCart = await fetchCartData();
      if (updatedCart) {
        // Force immediate cart display update
        await syncPochettesCheckbox();
        await updateCartItemsManually(updatedCart);
        await updateCartTotal(updatedCart);
        
        // Then check for gift eligibility
        await addGiftIfEligible(updatedCart);
        
        // Rebind buttons for the updated cart
        bindAjouterButtons();
        
        console.log("🔄 Cart display forcefully updated after gift removal");
      }
    } else {
      // No gift removal, proceed with normal gift check
      console.log("No gift removal - proceeding with normal gift check");
      await addGiftIfEligible(cart);
    }
  };

  // Flag to prevent multiple simultaneous gift additions
  let isAddingGift = false;
  
  // Function to remove gift product when cart becomes empty or total falls below threshold
  const removeGiftIfNotEligible = async (cart) => {
    console.log("🎁 removeGiftIfNotEligible called with cart:", cart);
    
    const cartTotal = cart.total_price / 100;
    const progressBars = document.querySelectorAll(".progress-bar");
    
    console.log("Cart total:", cartTotal);
    console.log("Progress bars found:", progressBars.length);
    
    const settingsElement = document.getElementById('cart-drawer-settings');  
    let giftVariantId;
    if (settingsElement) {
      const settings = JSON.parse(settingsElement.textContent);
      giftVariantId = settings.giftVariantId;
      console.log("Gift variant ID from settings:", giftVariantId);
    } else {
      giftVariantId = "8983145513287"; // Запасной вариант
      console.warn("cart-drawer-settings element not found, using fallback giftVariantId:", giftVariantId);
    }
    
    const giftInCart = cart.items.find(item => item.variant_id.toString() === giftVariantId);
    console.log("Gift in cart:", giftInCart);
    console.log("Cart items count:", cart.items.length);
    
    // Check if gift should be removed
    let shouldRemoveGift = false;
    
    // Remove gift if cart is completely empty
    if (cart.items.length === 0) {
      console.log("🔴 Cart is empty - should remove gift");
      shouldRemoveGift = true;
    } else {
      // Calculate total excluding the gift product itself
      const nonGiftItems = cart.items.filter(item => item.variant_id.toString() !== giftVariantId);
      const nonGiftTotal = nonGiftItems.reduce((total, item) => total + item.final_line_price, 0) / 100;
      
      console.log("Non-gift items:", nonGiftItems.length);
      console.log("Non-gift total:", nonGiftTotal);
      
      // Check if non-gift total falls below gift threshold
      for (const bar of progressBars) {
        let thresholdGift = parseInt(bar.dataset.thresholdGift) || 80;
        let progressMode = bar.dataset.progressMode || "shipping_and_gift";
        
        console.log(`Progress bar: mode=${progressMode}, threshold=${thresholdGift}`);
        
        if ((progressMode === "gift_only" || progressMode === "shipping_and_gift") && nonGiftTotal < thresholdGift) {
          console.log("🔴 Non-gift total below threshold - should remove gift");
          shouldRemoveGift = true;
          break;
        }
      }
    }
    
    console.log("Should remove gift:", shouldRemoveGift);
    
    // Remove gift if conditions are met and gift exists in cart
    if (shouldRemoveGift && giftInCart) {
      try {
        console.log("🎁 Removing gift product as conditions are no longer met");
        
        // For cart/change.js, we need to use the line item ID (not variant ID)
        // Convert the ID to string format to match Shopify's expected format
        const lineItemId = giftInCart.id.toString();
        await fetchWithRetry('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineItemId, quantity: 0 }),
        });
        console.log("✅ Gift product successfully removed from server");
        
        // Trigger cart:change event to notify other components
        document.dispatchEvent(new CustomEvent('cart:change', { 
          detail: { 
            cart: await fetchCartData(),
            giftRemoved: true 
          } 
        }));
        
        return true; // Gift was removed
      } catch (error) {
        console.error("Error removing gift from cart:", error);
        console.error("Failed payload (original ID):", { id: giftInCart.id, quantity: 0 });
        console.error("Failed payload (string ID):", { id: giftInCart.id.toString(), quantity: 0 });
      }
    }
    
    return false; // No gift removal needed or failed
  };
  
  // Функция для добавления подарка, если порог достигнут
  const addGiftIfEligible = async (cart) => {
    // Prevent multiple simultaneous gift additions
    if (isAddingGift) {
      
      return;
    }
    
    const cartTotal = cart.total_price / 100;
    const progressBars = document.querySelectorAll(".progress-bar");
    let giftAdded = false;

    const settingsElement = document.getElementById('cart-drawer-settings');
    let giftVariantId;
    if (settingsElement) {
      const settings = JSON.parse(settingsElement.textContent);
      giftVariantId = settings.giftVariantId;
    } else {
      giftVariantId = "8983145513287"; // Запасной вариант
      console.warn("cart-drawer-settings element not found, using fallback giftVariantId:", giftVariantId);
    }

    const giftInCart = cart.items.some(item => item.variant_id.toString() === giftVariantId);


    for (const bar of progressBars) {
      let thresholdGift = parseInt(bar.dataset.thresholdGift) || 80;
      let progressMode = bar.dataset.progressMode || "shipping_and_gift";


      if ((progressMode === "gift_only" || progressMode === "shipping_and_gift") && cartTotal >= thresholdGift && !giftInCart) {
        // Check if we can make an API call
        if (!canMakeApiCall()) {
          
          continue;
        }
        
        try {
          isAddingGift = true; // Set flag to prevent concurrent additions
          incrementApiCallCount(); // Track this API call
          const response = await fetchWithRetry('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: giftVariantId,
                  quantity: 1,
                },
              ],
            }),
          });
          
          giftAdded = true;
          break;
        } catch (error) {
          console.error("Error adding gift to cart:", error);
        } finally {
          isAddingGift = false; // Reset flag
        }
      }
    }

    if (giftAdded) {
      
      // Update cart display to show the newly added gift
      // Use a longer timeout and don't call updateProgressBars again to avoid recursion
      setTimeout(async () => {

        try {
          const updatedCart = await fetchCartData();
          if (updatedCart) {
            await syncPochettesCheckbox();
            await updateCartItemsManually(updatedCart);
            await updateCartTotal(updatedCart);
            // DON'T call updateProgressBars here to avoid recursion
            bindAjouterButtons();
          
          }
        } catch (error) {
          console.error("Error updating cart display after gift addition:", error);
        }
      }, 1000);
    }
  };

  // Функция для обновления общей суммы
  const updateCartTotal = (cart) => {
    const cartTotal = cart.total_price / 100;
    
    const totalElement = document.querySelector('.total-box span.total-price');
    if (totalElement) {
      totalElement.innerText = cartTotal.toFixed(2) + '€';
    }
  };

  // Привязка обработчиков для кнопки "AJOUTER"
  const bindAjouterButtons = () => {
    document.querySelectorAll('.recommendation-item .green-button').forEach(button => {
      button.removeEventListener('click', handleAjouterClick);
      button.addEventListener('click', handleAjouterClick);
    });
  };

  const handleAjouterClick = async (event) => {
    const button = event.currentTarget;
    const variantId = button.getAttribute('data-variant-id');
    
    if (!variantId) {
      console.error("Variant ID not found on button:", button);
      return;
    }

    // Check API rate limit
    if (!canMakeApiCall()) {
      
      return;
    }

    try {
      incrementApiCallCount(); // Track this API call
      const response = await fetchWithRetry('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(variantId),
              quantity: 1,
            },
          ],
        }),
      });

    
      await updateCartManually();

      if (typeof fbq !== 'undefined') {
        
        fbq('track', 'AddToCart', {
          content_ids: [variantId],
          content_type: 'product',
          value: 0,
          currency: 'EUR',
        });
      } else {
        console.warn("Facebook Pixel (fbq) not found on the page.");
      }
    } catch (error) {
      console.error("Error adding item to cart via AJOUTER:", error);
    }
  };

  // Логика слайдера для всех блоков cross-sell
  const sliders = document.querySelectorAll('.cart-recommendations');
  sliders.forEach(slider => {
    const sliderId = slider.id.replace('cross-sell-', '');
    const sliderContainer = document.getElementById(`recommendations-products-${sliderId}`);
    
    // Safety check: ensure sliderContainer exists
    if (!sliderContainer) {
      console.warn(`Slider container not found: recommendations-products-${sliderId}`);
      return;
    }
    
    const items = sliderContainer.querySelectorAll('.recommendations-item');
    const dots = slider.querySelectorAll('.pagination-dots .dot');
    let currentIndex = 0;

    function showItem(index) {
      items.forEach((item, i) => {
        if (item && item.classList) {
          item.classList.toggle('hidden', i !== index);
        }
      });
      dots.forEach((dot, i) => {
        if (dot && dot.classList) {
          dot.classList.toggle('active', i === index);
        }
      });
    }

    slider.querySelectorAll(`.slider-btn[data-slider-id="${sliderId}"]`).forEach(button => {
      button.addEventListener('click', function() {
        const direction = this.getAttribute('data-direction');
        if (direction === 'next') {
          currentIndex = (currentIndex + 1) % items.length;
        } else {
          currentIndex = (currentIndex - 1 + items.length) % items.length;
        }
        showItem(currentIndex);
      });
    });

    dots.forEach(dot => {
      dot.addEventListener('click', function() {
        currentIndex = parseInt(this.getAttribute('data-index'));
        showItem(currentIndex);
      });
    });
  });

  // Переключатель Pochettes с улучшенной логикой
  const syncPochettesCheckbox = async () => {
    const cart = await fetchCartData();
    if (cart) {
      document.querySelectorAll(".pochettes-container .toggle input").forEach((checkbox) => {
        const productId = checkbox.dataset.productId;
        const isInCart = cart.items.some(item => item.variant_id.toString() === productId);
        checkbox.checked = isInCart;
        
      });
    }
  };

  const handlePochetteToggle = debounce(async (checkbox) => {
    const productId = checkbox.dataset.productId;
    const wasChecked = checkbox.checked;
    
    // Check API rate limit
    if (!canMakeApiCall()) {
      
      checkbox.checked = !wasChecked; // Revert checkbox state
      return;
    }
    
    try {
      checkbox.disabled = true;
      incrementApiCallCount(); // Track this API call
      if (checkbox.checked) {
        const response = await fetchWithRetry("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: productId, quantity: 1 }),
        });
        
      } else {
        const response = await fetchWithRetry("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: productId, quantity: 0 }),
        });
        
      }
      await updateCartManually();
    } catch (error) {
      console.error("Error with Pochette toggle:", error);
      checkbox.checked = !wasChecked;
      alert("Erreur lors de la mise à jour du panier. Veuillez réessayer ou vérifier votre connexion.");
    } finally {
      checkbox.disabled = false;
    }
  }, 300); // Increased debounce time

  document.querySelectorAll(".pochettes-container .toggle input").forEach((checkbox) => {
    checkbox.addEventListener("change", () => handlePochetteToggle(checkbox));
  });

  // Общая функция обновления корзины
  const updateCart = debounce(async () => {
    const cart = await fetchCartData();
    if (cart) {
      await syncPochettesCheckbox();
      await updateCartItemsManually(cart);
      await updateCartTotal(cart);
      await updateProgressBars(cart);
      
      // Always bind AJOUTER buttons, even for empty cart (for recommendations)
      bindAjouterButtons();
      
      // Apply stone product logic after everything else is done
      // setTimeout(() => applyStoneProductLogic(), 200); // Removed - no longer hiding stone products
    }
  }, 200);

  // Инициализация при загрузке
  updateCart();

  // Обновление при изменении корзины - Restore event listener to fix BuyButtons integration
  document.addEventListener('cart:change', updateCart);
});

document.addEventListener('DOMContentLoaded', function () {
  const checkoutButton = document.querySelector('.checkout-btn');
  if (checkoutButton) {
    // Handle both click and touch events for better iOS compatibility
    const handleCheckout = function (event) {
      event.preventDefault();
      event.stopPropagation();
      
      // Add a small delay for iOS Safari compatibility
      setTimeout(function() {
        try {
          window.location.href = 'https://lespierresdubienetre.fr/checkout';
        } catch (error) {
          console.error('Checkout redirect failed:', error);
          // Fallback method
          window.location.assign('https://lespierresdubienetre.fr/checkout');
        }
      }, 100);
    };
    
    // Add multiple event listeners for better compatibility
    checkoutButton.addEventListener('click', handleCheckout);
    checkoutButton.addEventListener('touchend', handleCheckout);
    
    // Ensure the button is tappable on iOS
    checkoutButton.style.cursor = 'pointer';
    checkoutButton.style.webkitTouchCallout = 'none';
    checkoutButton.style.touchAction = 'manipulation';
  }
});